module.exports = __webpack_public_path__ + "img/call-report.4555b116.png";